import axios from "axios";
import ConstantList from "app/appConfig";
const API_PATH = ConstantList.API_ENPOINT + "/api/healthOrg";

export const pagingHealthOrgs = (searchObject) => {
  var url = API_PATH + "/searchByDto";
  return axios.post(url, searchObject);
};

export const getHealthOrg = (id) => {
  let url = API_PATH + "/" + id;
  return axios.get(url);
};

export const createHealthOrg = (obj) => {
  let url = API_PATH;
  return axios.post(url, obj);
};

export const editHealthOrg = (obj) => {
  let url = API_PATH + "/" + obj.id;
  return axios.put(url, obj);
};

export const deleteHealthOrg = (id) => {
  let url = API_PATH + "/" + id;
  return axios.delete(url);
};

export const checkCode = (dto) => {
  var url = API_PATH + "/checkCode";
  return axios.post(url, {...dto});
};

export const getAllHealthOrgs = () => {
  var url = API_PATH + "/getAll";
  return axios.get(url);
};

export const getChidrenByParent = (searchObject) => {
  var url = API_PATH + "/getChidrenByParent";
  return axios.post(url, searchObject);
};

export const pagdingEtbHealthOrganizations = (searchObject) => {
  var url = API_PATH + "/paging-etb-health-organizations";
  return axios.post(url, searchObject);
};

export const getAdministrativeUnitByHealOrgId = (organizationId) => {
  let url = API_PATH + "/get-by-man-org-id/" + organizationId;
  return axios.get(url);
}
